import { useSelector } from "react-redux";
import {
  decimalOddsValuesMap,
  fractionalOddsValuesMap,
  MARKETS_VIEW,
  ODDS_FILTER_DECIMAL_LABELS,
  ODDS_FILTER_FRACTIONAL_LABELS,
  ODDS_VIEW,
} from "../../../../constants";
import styles from "./FilterFavourites.module.scss";
import FilterGroup from "../FilterGroup";
import { generateDescription } from "../../../../lib/string";
import Alert from "../../../../components/Alert";

function FilterFavourites() {
  const { storedFavourites } = useSelector((state) => state.filter);
  const { loggedIn } = useSelector((state) => state.view);
  const { format } = useSelector((state) => state.betslip);

  const markets = storedFavourites
    .filter((favourite) => favourite.type === MARKETS_VIEW)
    .map((favourite) => {
      const description = generateDescription(favourite.markets);
      return {
        ...favourite,
        description,
      };
    });

  const odds = storedFavourites
    .filter((favourite) => favourite.type === ODDS_VIEW)
    .map((favourite) => {
      let description = "";
      // check if favourite odds uses the existing decimal ranges
      const isLegacyDecimalRange =
        decimalOddsValuesMap.get(favourite.odds.minOdds) !== undefined &&
        decimalOddsValuesMap.get(favourite.odds.maxOdds);

      if (isLegacyDecimalRange) {
        if (format === "Decimal") {
          description = `${decimalOddsValuesMap.get(
            favourite.odds.minOdds
          )} - ${decimalOddsValuesMap.get(favourite.odds.maxOdds)}`;
        } else {
          description = `${fractionalOddsValuesMap.get(
            favourite.odds.minOdds
          )} - ${fractionalOddsValuesMap.get(favourite.odds.maxOdds)}`;
        }
      } else {
        if (format === "Decimal") {
          description = `${ODDS_FILTER_DECIMAL_LABELS.get(
            favourite.odds.minOdds ?? 0
          )} - ${ODDS_FILTER_DECIMAL_LABELS.get(
            favourite.odds.maxOdds ?? Infinity
          )}`;
        } else {
          description = `${ODDS_FILTER_FRACTIONAL_LABELS.get(
            favourite.odds.minOdds ?? 0
          )} - ${ODDS_FILTER_FRACTIONAL_LABELS.get(
            favourite.odds.maxOdds ?? Infinity
          )}`;
        }
      }
      return {
        ...favourite,
        description,
      };
    });

  if (!loggedIn) {
    return (
      <Alert>
        <h4 className={styles.noFavouritesHeading}>One sec there, mate</h4>
        <p className={styles.noFavouritesDescription}>
          You need to be logged in to select your favourites.
        </p>
      </Alert>
    );
  }

  if (storedFavourites.length === 0)
    return (
      <Alert>
        <h4 className={styles.noFavouritesHeading}>
          You haven&apos;t added any Favourites yet
        </h4>
        <p className={styles.noFavouritesDescription}>
          Select your most used filters and add them as favourites.
        </p>
      </Alert>
    );

  return (
    <div className={styles.favourites}>
      {Boolean(markets?.length > 0) && (
        <FilterGroup type={MARKETS_VIEW} group={markets} />
      )}
      {Boolean(odds?.length > 0) && (
        <FilterGroup type={ODDS_VIEW} group={odds} />
      )}
    </div>
  );
}

export default FilterFavourites;
